import Service from "../../../service/api.js";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {

        item:[],
        status:[],
        plans:{
            overview: {
                people: 0,
                items: 0,
                levels: 0,
                completed: 0,
                pending: 0
            },
            items:[]
        },
        isReload: false,

        members:[]
    },

    mutations: {
        item(state, obj) {
            state.item = obj;
        },

        status(state, obj) {
            state.status = obj;
        },

        plans(state, obj) {
            state.plans = obj;
        },

        isReload(state, obj) {
            state.isReload = obj;
        },

        members(state, data) {
            state.members = data;
        }
    },

    actions: {
        config({commit}, data) {
            return Service.Report_Assessment('report_assessment', data, {})
                .then((response) => {
                    store.commit("report/item", response.data.data)
                    store.commit("report/isReload",true)
                    return response
                }).catch((err) => {
                    throw err
            });
        },
        members({commit}, data) {
            return Service.idpReportCompetency('explore', data, {})
                .then((response) => {
                    store.commit("report/members", response.data.data)
                    return response
                }).catch((err) => {
                    throw err
            });
        },


        status({commit}, data) {
            return Service.idpReportCompetency('status', data, {})
                .then((response) => {
                    store.commit("report/status", (((response || {}).data || {}).data || [])[0]?.item || [])
                    store.commit("report/isReload",true)
                    return response
                }).catch((err) => {
                    throw err
            });
        },




        plans({commit}, data) {
            return Service.idpReportCompetency('plans-summary', data, {})
                .then((response) => {
                    store.commit("report/plans", response.data.data)
                    store.commit("report/isReload",true)
                    return response
                }).catch((err) => {
                    throw err
            });
        },

    },

    getters: {
        item(state, obj) {
            return state.item;
        },
        status(state, obj) {
            return state.status;
        },
        plans(state, obj) {
            return state.plans;
        },
        isReload(state, obj) {
            return state.isReload;
        },
        members(state, obj) {
            return state.members;
        }
    },
};

export default ServerModule;
